import { render, staticRenderFns } from "./tackXq.vue?vue&type=template&id=b9207ed0&scoped=true"
import script from "./tackXq.vue?vue&type=script&lang=js"
export * from "./tackXq.vue?vue&type=script&lang=js"
import style0 from "./tackXq.vue?vue&type=style&index=0&id=b9207ed0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9207ed0",
  null
  
)

export default component.exports